import { IContrato, IDocumento } from './downloadDocumentos';

export default function InstanceOfDocument(doc: IDocumento | IContrato ): doc is IContrato{
  return 'binDocumento' in doc;
}
